import { defaultSalesDetailDto, SalesDetailDto } from "src/dtos/sales/salesBillDto";

/**
 * SAL2110_R01 - 영업 매출 내역 조회 DTO
 * 매출 상세(SalesDetailDto)를 기반으로 한 조회 행
 */
export interface SAL2110_R01Dto extends SalesDetailDto {
	brandCd: string;			// 브랜드코드
	brandNm: string;			// 브랜드명
	totalAmt: number;			// 매출액
	rowKey: string;				// 집계 행 고유 키 (테이블별 prefix + 그룹코드)
}

/**
 * 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultSAL2110_R01Dto: SAL2110_R01Dto = {
	...defaultSalesDetailDto,
	brandCd: '',
	brandNm: '',
	totalAmt: 0,
	rowKey: '',
};
